import {Component, Input, OnInit} from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {Question, Section} from "@screens/activities/forms/forms.models";
import {MsformsService} from "@app/services/msforms.service";
import {Organization} from "@screens/set-organizations/store/organizations.models";
import {OrganizationsService} from "@app/services/organizations.service";
import {BrowserModule} from "@angular/platform-browser";
import {CommonModule} from "@angular/common";
import {
  AbstractControlOptions,
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import * as _ from 'lodash';
import {AccountService} from "@app/services";

@Component({
  selector: 'ngbd-modal-connect-org',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  template: `
    <div class="modal-header p-0 border-0">
      <div class="row mx-0 w-100">
        <h2 class="modal-title font-size-24 font-solomon-bold w-100 blue-0041A3 pl-4 mt-3" id="modalchangeTitle">Seleccionar cliente para administrar</h2>
      </div>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="margin: 0!important;"
              (click)="activeModal.dismiss('Cross click')">
        <i class="icon-close blue-0041A3 font-size-18"></i>
      </button>
    </div>
    <div class="modal-body px-4 pb-5 pt-0">
      <div class="row mx-0">
        <p class="font-solomon font-size-14 gray-9EACB3 mb-1">Permite administrar una organización</p>

        <form [formGroup]="form" (submit)="onSubmit()"  class="post-form forms-admin col-12 px-0">

          <div class="form-group">
            <div class="form-group"><label for="id_name">Cliente que va ser administrado</label>
              <select class="form-control" formControlName="organization_id" >
                <option value="" selected disabled >Seleccione</option>
                <option [value]="organization.id" *ngFor="let organization of organizations">{{organization.name}}</option>
              </select>
            </div>
          </div>
          <div class="text-center">
            <button type="submit" class="btn btn-block btn-save" [disabled]="form.invalid">Cambiar organización</button>
            <button type="button" class="btn btn-link text-danger" (click)="cancel()">Cancelar cambio</button>
          </div>
        </form>

      </div>

    </div>
	`,
})
export class NgbdModalConnectedOrgContent implements  OnInit {
  organizations: Organization[];

  public form: FormGroup = this.fb.group({
    organization_id: ['', Validators.required],
  },{
    validators: []
  }  as AbstractControlOptions)


  constructor(public activeModal: NgbActiveModal,
              private organizationService: OrganizationsService,
              private fb: FormBuilder,
              private accountsService: AccountService
              ) {}

  ngOnInit(): void {
    const user = this.accountsService.userValue;
    if (user?.user_type === 3) { // UserType.Merchandising
      this.getOrganizationsMercha();
    } else {
      this.getOrganizations();
    }
  }

  getOrganizations(pagination: boolean = false){
    return this.organizationService.getAll("", pagination).subscribe(
      (response: any) => {
        this.organizations = response;
      })
  }
   getOrganizationsMercha(pagination: boolean = false){
    return this.organizationService.getAllMercha("", pagination).subscribe(
      (response: any) => {
        this.organizations = response;
      })
  }
  onSubmit(){
    console.warn(this.form.value);
    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    const org = _.find(this.organizations, {id: Number(this.form.value.organization_id)})

    console.log(org)
    if(org){
      this.accountsService.connectToOrganization(org)
    }else{
      this.accountsService.connectToOrganization(null)
    }

    this.activeModal.dismiss();
    window.location.reload();
  }

  cancel(){
    this.accountsService.connectToOrganization(null)
    this.activeModal.dismiss();
    window.location.reload();
  }
}
